/* eslint-disable */
export default {
  sureToDeleteVoiceMail: '¿Seguro que desea eliminar este mensaje de voz?',
  sureToDeleteFax: '¿Seguro que desea eliminar este fax?',
  doNotAskAgain: 'No volver a preguntar',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
